const SETTINGS_MODAL_HASH_PREFIX = '#settings_tab-default-';
const LEGACY_SETTINGS_MODAL_HASH_PREFIX = '#settings_tab=default:';

function getNavigationCallbacks(options = {}) {
    return {
        syncRoleplaySettingsTabVisibility: options.syncRoleplaySettingsTabVisibility || (() => {}),
        syncRoleplaySettingsToggleState: options.syncRoleplaySettingsToggleState || (() => {}),
        stopVoicePreview: options.stopVoicePreview || (() => {}),
    };
}

function normalizeSettingsModalTabTarget(tabTarget = '') {
    const normalized = (tabTarget || '').toString().trim();

    if (!normalized) {
        return '#settings-content';
    }

    return normalized.startsWith('#') ? normalized : `#${normalized}`;
}

function getSettingsModalActiveTabTarget($modal = $('#growtypeChatSettingsModal')) {
    const activeTab = $modal.find('.chat-settings-tabs .nav-link.active').first();
    return normalizeSettingsModalTabTarget(activeTab.attr('data-bs-target') || '#settings-content');
}

function getSettingsModalTabTargetFromHash() {
    const hash = (window.location.hash || '').trim();

    if (hash.startsWith(SETTINGS_MODAL_HASH_PREFIX)) {
        return normalizeSettingsModalTabTarget(hash.slice(SETTINGS_MODAL_HASH_PREFIX.length));
    }

    if (hash.startsWith(LEGACY_SETTINGS_MODAL_HASH_PREFIX)) {
        const normalizedTabTarget = normalizeSettingsModalTabTarget(hash.slice(LEGACY_SETTINGS_MODAL_HASH_PREFIX.length));
        updateSettingsModalHash(normalizedTabTarget);

        return normalizedTabTarget;
    }

    return '';
}

function updateSettingsModalHash(tabTarget = '#settings-content') {
    const normalizedTabTarget = normalizeSettingsModalTabTarget(tabTarget).replace(/^#/, '');
    const newHash = `${SETTINGS_MODAL_HASH_PREFIX}${normalizedTabTarget}`;
    const newUrl = `${window.location.origin}${window.location.pathname}${window.location.search}${newHash}`;

    window.history.replaceState({}, document.title, newUrl);
}

function clearSettingsModalHash() {
    const hash = (window.location.hash || '').trim();

    if (!hash.startsWith(SETTINGS_MODAL_HASH_PREFIX)) {
        return;
    }

    const newUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    window.history.replaceState({}, document.title, newUrl);
}

function showSettingsModalTab($modal, tabTarget) {
    const normalizedTabTarget = normalizeSettingsModalTabTarget(tabTarget);
    const $tabButton = $modal.find(`[data-bs-target="${normalizedTabTarget}"]`).first();

    if (!$tabButton.length) {
        return;
    }

    $modal.find('.chat-settings-tabs .nav-link').removeClass('active').attr('aria-selected', 'false');
    $modal.find('.tab-content .tab-pane').removeClass('active show');

    $tabButton.addClass('active').attr('aria-selected', 'true');
    const $targetPane = $modal.find(normalizedTabTarget);
    if ($targetPane.length) {
        $targetPane.addClass('active show');
    }

    if (typeof bootstrap !== 'undefined' && bootstrap?.Tab) {
        try {
            bootstrap.Tab.getOrCreateInstance($tabButton[0]).show();
        } catch (error) {
            // The manual class update above supports pages without the full Bootstrap API.
        }
    }
}

export function openSettingsModalTab(tabTarget = '#settings-content') {
    const $modal = jQuery('#growtypeChatSettingsModal');

    if (!$modal.length) {
        return false;
    }

    const normalizedTabTarget = normalizeSettingsModalTabTarget(tabTarget);
    showSettingsModalTab($modal, normalizedTabTarget);
    updateSettingsModalHash(normalizedTabTarget);

    if (typeof bootstrap !== 'undefined' && bootstrap?.Modal) {
        try {
            bootstrap.Modal.getOrCreateInstance($modal[0]).show();
        } catch (error) {
            $modal.modal('show');
        }
    } else if (typeof $modal.modal === 'function') {
        $modal.modal('show');
    }

    return true;
}

export function openSettingsModalFromHash(options = {}) {
    const {syncRoleplaySettingsTabVisibility, syncRoleplaySettingsToggleState} = getNavigationCallbacks(options);
    const tabTarget = getSettingsModalTabTargetFromHash();

    if (!tabTarget) {
        return;
    }

    const $modal = $('#growtypeChatSettingsModal');
    if (!$modal.length) {
        return;
    }

    syncRoleplaySettingsTabVisibility();
    syncRoleplaySettingsToggleState();
    openSettingsModalTab(tabTarget);
}

export function bindSettingsModalNavigation(options = {}) {
    const {syncRoleplaySettingsTabVisibility, syncRoleplaySettingsToggleState, stopVoicePreview} = getNavigationCallbacks(options);
    jQuery('#growtypeChatSettingsModal')
        .off('show.bs.modal.settingsModalHash')
        .on('show.bs.modal.settingsModalHash', function () {
            const hashTarget = getSettingsModalTabTargetFromHash();
            const targetToSync = hashTarget || getSettingsModalActiveTabTarget(jQuery(this));
            if (hashTarget) {
                showSettingsModalTab(jQuery(this), hashTarget);
            }
            updateSettingsModalHash(targetToSync);
        })
        .off('hide.bs.modal.voice')
        .on('hide.bs.modal.voice', stopVoicePreview)
        .off('hide.bs.modal.settingsModalHash')
        .on('hide.bs.modal.settingsModalHash', clearSettingsModalHash)
        .off('shown.bs.modal.roleplayTabSync')
        .on('shown.bs.modal.roleplayTabSync', function () {
            syncRoleplaySettingsTabVisibility();
            syncRoleplaySettingsToggleState();
        });

    jQuery(document)
        .off('shown.bs.tab.settingsModalHash', '#growtypeChatSettingsModal [data-bs-toggle="tab"]')
        .on('shown.bs.tab.settingsModalHash', '#growtypeChatSettingsModal [data-bs-toggle="tab"]', function () {
            updateSettingsModalHash(jQuery(this).attr('data-bs-target') || '#settings-content');
        });
}
